(function (scope) {
  'use strict';
  const QA_THEME = '188978331830', MAIN_THEME = '150090219702';
  const CONTRACT = 'shopify-v18-clearance-20261020';
  const HOST = '[data-netrition-plan-host]';
  const positive = value => (typeof value === 'number' || (typeof value === 'string' && /^\d+$/.test(value))) && Number.isSafeInteger(Number(value)) && Number(value) > 0;
  const id = value => value == null ? null : String(value);
  function validateRegistry(input) {
    if (!input || !/^[A-Z]{3}$/.test(input.currency) || !Array.isArray(input.lines)) throw new Error('Plan data is unavailable. Reload and try again.');
    const keys = new Set();
    input.lines.forEach((line, index) => {
      if (!line || typeof line.key !== 'string' || !line.key || keys.has(line.key) || line.line !== index + 1 || !positive(line.variantId) || !positive(line.quantity) || !Number.isSafeInteger(line.oneTimePrice) || line.oneTimePrice < 0 || !Array.isArray(line.plans) || ['available', 'clearance', 'requiresPlan'].some(key => typeof line[key] !== 'boolean')) throw new Error('Cart data changed. Reload and try again.');
      keys.add(line.key);
      const plans = new Set();
      line.plans.forEach(plan => {
        if (!positive(plan.id) || plans.has(id(plan.id)) || typeof plan.name !== 'string' || !plan.name || !Number.isSafeInteger(plan.price) || plan.price < 0) throw new Error('Plan data is unavailable. Reload and try again.');
        plans.add(id(plan.id));
      });
      if (line.currentPlanId != null && !positive(line.currentPlanId)) throw new Error('The current plan could not be verified.');
    });
    return input;
  }
  function signature(registry) {
    return JSON.stringify([registry.currency, registry.lines.map(line => [line.key, id(line.variantId), line.quantity, id(line.currentPlanId), line.currentPlanName, line.oneTimePrice, line.available, line.clearance, line.requiresPlan, line.plans.map(plan => [id(plan.id), plan.name, plan.price, plan.compareAtPrice])])]);
  }
  function resolveLine(registry, host) {
    const matches = registry.lines.filter(line => line.key === host.key);
    if (matches.length !== 1 || id(matches[0].variantId) !== id(host.variantId) || Number(matches[0].quantity) !== Number(host.quantity)) throw new Error('This cart item changed. Reload and choose again.');
    return matches[0];
  }
  function buildChange(displayed, fresh, host, selected) {
    validateRegistry(displayed); validateRegistry(fresh);
    if (signature(displayed) !== signature(fresh)) throw new Error('Your cart changed. Review it and choose again.');
    const line = resolveLine(fresh, host);
    if (!line.available) throw new Error('This variant is unavailable.');
    if (fresh.lines.filter(item => id(item.variantId) === id(line.variantId)).length !== 1) throw new Error('This variant appears more than once. Reload before changing its plan.');
    const target = selected === '' ? null : id(selected);
    if (target === id(line.currentPlanId)) return null;
    if (target == null) {
      if (line.requiresPlan) throw new Error('This item requires a subscription.');
    } else if (line.clearance || !line.plans.some(plan => id(plan.id) === target)) {
      throw new Error('That subscription is not available for this variant.');
    }
    return { line: line.line, quantity: line.quantity, selling_plan: target == null ? null : Number(target) };
  }
  function responseFailure(code, message) { const error = new Error(message); error.planCode = code; throw error; }
  function verifyResponse(cart, before, targetKey, payload) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length !== before.lines.length) responseFailure('response-shape', 'The cart response changed unexpectedly. Reload to verify it before trying again.');
    const target = before.lines.find(line => line.key === targetKey);
    const planId = item => id(item.selling_plan_allocation?.selling_plan?.id);
    const matches = cart.items.filter(item => id(item.variant_id) === id(target.variantId));
    if (matches.length !== 1) responseFailure('target-count', 'The requested plan could not be confirmed. Reload to verify the cart.');
    if (matches[0].quantity !== payload.quantity) responseFailure('target-quantity', 'The requested plan could not be confirmed. Reload to verify the cart.');
    if (planId(matches[0]) !== id(payload.selling_plan)) responseFailure('target-plan', 'The requested plan could not be confirmed. Reload to verify the cart.');
    for (const line of before.lines.filter(line => line.key !== targetKey)) {
      const items = cart.items.filter(item => item.key === line.key);
      if (items.length !== 1) responseFailure('other-key', 'Another cart item changed. Reload to verify the cart before continuing.');
      if (id(items[0].variant_id) !== id(line.variantId)) responseFailure('other-variant', 'Another cart item changed. Reload to verify the cart before continuing.');
      if (items[0].quantity !== line.quantity) responseFailure('other-quantity', 'Another cart item changed. Reload to verify the cart before continuing.');
      if (planId(items[0]) !== id(line.currentPlanId)) responseFailure('other-plan', 'Another cart item changed. Reload to verify the cart before continuing.');
    }
    return true;
  }
  function verifyReadback(before, after, targetKey, payload) {
    validateRegistry(before); validateRegistry(after);
    if (before.currency !== after.currency || before.lines.length !== after.lines.length) responseFailure('readback-shape', 'The cart changed unexpectedly. Reload to verify it before trying again.');
    const target = before.lines.find(line => line.key === targetKey);
    const matches = after.lines.filter(line => id(line.variantId) === id(target.variantId));
    if (matches.length !== 1 || matches[0].quantity !== payload.quantity || id(matches[0].currentPlanId) !== id(payload.selling_plan)) responseFailure('readback-target', 'The requested plan could not be confirmed. Reload to verify the cart.');
    const current = matches[0];
    const selected = payload.selling_plan == null ? null : target.plans.find(plan => id(plan.id) === id(payload.selling_plan));
    const expected = { ...target, key: current.key, line: current.line, currentPlanId: payload.selling_plan, currentPlanName: selected ? selected.name : null };
    if (signature({currency:before.currency,lines:[expected]}) !== signature({currency:after.currency,lines:[current]})) responseFailure('readback-terms', 'The requested plan terms could not be confirmed. Reload to verify the cart.');
    for (const line of before.lines.filter(line => line.key !== targetKey)) {
      const items = after.lines.filter(item => item.key === line.key);
      if (items.length !== 1 || signature({currency:before.currency,lines:[line]}) !== signature({currency:after.currency,lines:items})) responseFailure('readback-other', 'Another cart item changed. Reload to verify the cart before continuing.');
    }
    return true;
  }
  const api = { validateRegistry, signature, resolveLine, buildChange, verifyResponse, verifyReadback };
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!scope.document) return;

  const document = scope.document;
  const loader = document.currentScript || document.querySelector('script[data-netrition-plan-selector]');
  const THEME = loader?.dataset.themeId;
  if (!loader || ![QA_THEME, MAIN_THEME].includes(THEME) || loader.dataset.registrySection !== 'netrition-cart-plans') return;
  const changeUrl = new URL(loader.dataset.cartChangeUrl, scope.location.origin);
  if (changeUrl.origin !== scope.location.origin || !/\/cart\/change\.js$/.test(changeUrl.pathname)) return;
  const busyOwner = 'plan-selector';
  const acquireBusy = () => { const busy=document.documentElement.dataset.netritionCartBusy;if(busy)return false;document.documentElement.dataset.netritionCartBusy=busyOwner;return true; };
  const releaseBusy = () => {if(document.documentElement.dataset.netritionCartBusy===busyOwner)delete document.documentElement.dataset.netritionCartBusy;};
  let registry;
  let pending = false;
  let updateFailed = false;
  let failureMessage = "";
  let refreshQueued = false;
  let generation = 0;
  let invalidated = false;
  let observer;
  let serial = 0;
  const states = new WeakMap();
  loader.dataset.netritionPlanState = 'waiting-for-cart';
  const previewContext = () => {
    const params = new URL(scope.location.href).searchParams;
    const cart=params.get('preview_smart_cart'),version=params.get('cart_version');
    return THEME===QA_THEME ? cart==='38443'&&version==='2' : (!cart||cart==='38443')&&(!version||version==='2');
  };
  const protectedRoot = () => {
    if (!previewContext()) return null;
    const roots = document.querySelectorAll('#rebuy-cart [data-netrition-plan-contract="' + CONTRACT + '"][data-netrition-smart-cart-id="38443"]');
    return roots.length === 1 ? roots[0] : null;
  };
  const hosts = () => Array.from(protectedRoot()?.querySelectorAll(HOST) || []);
  const hostData = host => ({ key: host.dataset.netritionLineKey, variantId: host.dataset.netritionVariantId, quantity: host.dataset.netritionLineQuantity });
  function parseRegistry(html) {
    const parsed = new scope.DOMParser().parseFromString(html, 'text/html');
    const scripts = parsed.querySelectorAll('script#netrition-cart-plans[data-netrition-theme-id="' + THEME + '"]');
    if (scripts.length !== 1) throw new Error('Plan data is unavailable. Reload and try again.');
    return validateRegistry(JSON.parse(scripts[0].textContent));
  }
  async function loadRegistry() {
    const url = new URL(scope.location.href);
    url.searchParams.delete('sections');
    url.searchParams.delete('sections[]');
    url.searchParams.set('section_id', 'netrition-cart-plans');
    if (THEME === QA_THEME) url.searchParams.set('preview_theme_id', THEME);
    else { url.searchParams.delete('preview_theme_id'); url.searchParams.delete('preview_smart_cart'); url.searchParams.delete('cart_version'); }
    url.searchParams.delete('viewcart');
    url.searchParams.delete('netrition_test_recommendation');
    loader.dataset.netritionPlanStage = 'requesting-section';
    const response = await scope.fetch(url.href, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Could not load the available plans. Try again.');
    loader.dataset.netritionPlanStage = 'reading-section-html';
    const html = await response.text();
    if (typeof html !== 'string' || !html.trim()) throw new Error('Plan data is unavailable. Reload and try again.');
    loader.dataset.netritionPlanStage = 'validating-plan-data';
    return parseRegistry(html);
  }
  // Refresh Rebuy's cart in place so the drawer stays open. Resolves false when
  // Rebuy cannot refresh (missing, busy or silent), and the caller reloads instead.
  function refreshCart() {
    return new Promise(resolve => {
      let done = false;
      const finish = ok => { if (done) return; done = true; scope.clearTimeout?.(timer); resolve(ok); };
      const timer = scope.setTimeout(() => finish(false), 10000);
      try {
        const cart = scope.Rebuy?.Cart;
        if (!cart || typeof cart.fetchCart !== 'function' || cart.fetchCart(() => finish(true)) === false) finish(false);
      } catch (_) { finish(false); }
    });
  }
  function showStatus(state, text, error) {
    state.status.textContent = text;
    if (error) state.select.setAttribute('aria-invalid', 'true');
    else state.select.removeAttribute('aria-invalid');
  }
  function renderFailure() {
    const root = protectedRoot();
    if (!updateFailed || !failureMessage || !root) return;
    let status = root.querySelector('[data-netrition-plan-error]');
    if (!status) { status = document.createElement('p'); status.setAttribute('role', 'alert'); status.setAttribute('data-netrition-plan-error', ''); root.prepend(status); }
    if (status.textContent !== failureMessage) status.textContent = failureMessage;
  }
  function render(host) {
    if (!registry || pending || updateFailed || !protectedRoot()?.contains(host)) return;
    let line;
    try { line = resolveLine(registry, hostData(host)); } catch (_) { host.replaceChildren(); states.delete(host); return; }
    const stamp = JSON.stringify([line, registry.currency]);
    const prior = states.get(host);
    if (prior && prior.stamp === stamp) return;
    const label = document.createElement('label');
    const select = document.createElement('select');
    const status = document.createElement('p');
    const selectId = 'netrition-plan-' + (++serial);
    label.htmlFor = selectId;
    label.textContent = 'Delivery frequency';
    select.id = selectId;
    select.className = 'rebuy-select muted';
    const productTitle = host.closest('.rebuy-cart__flyout-item')?.querySelector('.rebuy-cart__flyout-item-product-title')?.textContent.trim();
    if (productTitle) select.setAttribute('aria-label', 'Delivery frequency for ' + productTitle);
    select.setAttribute('aria-describedby', selectId + '-status');
    status.id = selectId + '-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: registry.currency }).format(cents / 100);
    const option = (value, text, disabled) => { const node = document.createElement('option'); node.value = value; node.textContent = text; node.disabled = !!disabled; select.append(node); };
    if (!line.requiresPlan) option('', 'One-time purchase · ' + money(line.oneTimePrice));
    if (!line.clearance) line.plans.forEach(plan => option(id(plan.id), plan.name + ' · ' + money(plan.price)));
    const current = id(line.currentPlanId);
    const knownCurrent = current == null || line.plans.some(plan => id(plan.id) === current);
    if (current && (line.clearance || !knownCurrent)) option(current, line.currentPlanName || 'Current subscription', true);
    select.value = current || '';
    const availableChoices = Array.from(select.options).filter(node => !node.disabled);
    select.disabled = !line.available || !knownCurrent || availableChoices.length === 0 || (line.clearance && current == null);
    if (line.clearance) status.textContent = current ? 'Subscriptions are unavailable for clearance items. You can choose one-time purchase.' : 'One-time purchase only.';
    else if (!knownCurrent) status.textContent = 'The current plan could not be verified. Reload before making changes.';
    else if (!line.available) status.textContent = 'This variant is unavailable.';
    else if (!line.plans.length) status.textContent = 'No subscriptions are available for this variant.';
    const state = { select, status, stamp, line, host, registry };
    states.set(host, state);
    host.replaceChildren(label, select, status);
    select.addEventListener('change', () => change(state));
  }
  async function change(state) {
    if (pending || updateFailed || !state.host.isConnected || !protectedRoot()?.contains(state.host)) return;
    if (!acquireBusy()) return;
    pending = true;
    invalidated = false;
    let succeeded = false;
    let refreshed = false;
    const desired = state.select.value;
    loader.dataset.netritionPlanState = 'updating';
    hosts().forEach(host => { const existing = states.get(host); if (existing) existing.stamp = ''; const select = host.querySelector('select'); if (select) select.disabled = true; });
    showStatus(state, 'Updating delivery frequency…', false);
    try {
      const fresh = await loadRegistry();
      if (invalidated || !state.host.isConnected || !protectedRoot()?.contains(state.host)) throw new Error('The cart changed. Reload and choose again.');
      const payload = buildChange(state.registry, fresh, hostData(state.host), desired);
      if (!payload) { showStatus(state, '', false); return; }
      loader.dataset.netritionPlanStage = 'posting-change';
      const response = await scope.fetch(changeUrl.href, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error('Could not change the delivery frequency. Reload before trying again.');
      // Read the complete authoritative cart from the same no-store Shopify section.
      // A successful status or an intercepted POST body alone cannot acknowledge a plan.
      loader.dataset.netritionPlanStage = 'confirming-plan-data';
      if (!protectedRoot()) responseFailure('context', 'The preview context changed during this update. Reload to verify the cart.');
      const after = await loadRegistry();
      if (!protectedRoot()) responseFailure('context', 'The preview context changed during this update. Reload to verify the cart.');
      verifyReadback(fresh, after, state.line.key, payload);
      loader.dataset.netritionPlanState = 'refreshing';
      if (!(await refreshCart())) {
        loader.dataset.netritionPlanState = 'reloading';
        scope.location.reload();
        succeeded = true;
        return;
      }
      registry = after;
      refreshed = true;
    } catch (error) {
      updateFailed = true;
      state.select.value = id(state.line.currentPlanId) || '';
      const message = error.message || 'Could not update this plan. Reload and try again.';
      failureMessage = message;
      if (state.status.isConnected && protectedRoot()?.contains(state.status)) showStatus(state, message, true);
      renderFailure();
      loader.dataset.netritionPlanState = 'error';
      loader.dataset.netritionPlanErrorName = error.name || 'Error';
      loader.dataset.netritionPlanErrorCode = error.planCode || 'update-unconfirmed';
      registry = null;
    } finally {
      if (!succeeded) {
        pending = false;
        if (!updateFailed) releaseBusy();
        if (registry) { hosts().forEach(host => { const existing = states.get(host); if (existing) { existing.stamp = ''; render(host); } }); loader.dataset.netritionPlanState = 'ready'; }
        if (refreshed) schedule();
      }
    }
  }
  async function refresh() {
    refreshQueued = false;
    if (pending || updateFailed || !protectedRoot()?.querySelector(HOST)) return;
    const request = ++generation;
    loader.dataset.netritionPlanState = 'loading';
    try {
      const next = await loadRegistry();
      if (request !== generation || pending || updateFailed || !protectedRoot()) return;
      registry = next;
      hosts().forEach(render);
      loader.dataset.netritionPlanState = 'ready';
      loader.removeAttribute('data-netrition-plan-error-name');
    } catch (error) {
      registry = null;
      loader.dataset.netritionPlanState = 'unavailable';
      loader.dataset.netritionPlanErrorName = error.name || 'Error';
      hosts().forEach(host => { const select = host.querySelector('select'); if (select) select.disabled = true; });
      hosts().filter(host => !host.querySelector('select')).forEach(host => {
        const status = document.createElement('p');
        status.setAttribute('role', 'status');
        status.textContent = 'Delivery options are unavailable. Reload and try again.';
        host.replaceChildren(status);
      });
    }
  }
  function schedule() {
    if (refreshQueued || pending || updateFailed) return;
    refreshQueued = true;
    scope.setTimeout(refresh, 80);
  }
  observer = new scope.MutationObserver(records => {
    if (updateFailed) { renderFailure(); return; }
    const containsHost = node => node.nodeType === 1 && (node.matches(HOST) || node.querySelector(HOST));
    if (records.some(record => record.type === 'attributes' || [...record.addedNodes, ...record.removedNodes].some(containsHost))) { if (pending) invalidated = true; schedule(); }
  });
  observer.observe(document, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-netrition-line-key', 'data-netrition-variant-id', 'data-netrition-line-quantity'] });
  document.addEventListener('rebuy:cart.change', () => { if (pending) invalidated = true; generation++; schedule(); });
  scope.addEventListener?.('popstate', () => { if (pending) invalidated = true; generation++; schedule(); });
  const blockOtherControls = event => {
    if ((pending || document.documentElement.dataset.netritionCartBusy) && event.target.closest?.('#rebuy-cart')) { event.preventDefault(); event.stopImmediatePropagation(); }
  };
  ['click', 'change', 'input', 'submit'].forEach(type => document.addEventListener(type, blockOtherControls, true));
  schedule();
})(typeof window === 'undefined' ? globalThis : window);
